import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../components/Services.css';
import '../components/About.css';

const VolunteeringTeamPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const teamInfo = {
    title: 'Volunteering & Community Engagement',
    description: 'Because change happens face-to-face. Our volunteers bring energy, empathy, and engagement straight to seniors through interactive game nights, social events, and meaningful one-on-one connections. We organize and host these experiences in senior homes, ensuring that every event fosters real relationships, combats isolation, and promotes health.',
    video: '/videos/6646663-hd_1080_1920_24fps.mp4',
    keyPoints: [
      'Organize interactive game nights at senior homes',
      'Host social events and activities for seniors',
      'Build meaningful one-on-one connections',
      'Combat isolation and promote health',
      'Create opportunities for intergenerational bonding',
      'Plan and coordinate community engagement events'
    ],
    skills: [
      'Event Planning',
      'Communication',
      'Empathy & Patience',
      'Organization',
      'Community Outreach',
      'Interpersonal Skills'
    ]
  };

  return (
    <div className="page-container">
      <section className="services section" ref={sectionRef}>
        <div className="container">
          <div className={`services-header ${isVisible ? 'animate-fade-in' : ''}`}>
            <h1 className="section-title">{teamInfo.title}</h1>
            <p className="section-subtitle">
              {teamInfo.description}
            </p>
          </div>

          <div className={`team-hero-section ${isVisible ? 'animate-slide-up' : ''}`}>
            <div className="team-hero-video">
              <video 
                src={teamInfo.video} 
                className="team-bg-video"
                autoPlay
                muted
                loop
                playsInline
              />
            </div>
          </div>

          <div className="team-details-grid">
            <div className={`team-details-card ${isVisible ? 'animate-slide-left' : ''}`}>
              <h2>What We Do</h2>
              <ul className="team-key-points">
                {teamInfo.keyPoints.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>

            <div className={`team-details-card ${isVisible ? 'animate-slide-right' : ''}`}>
              <h2>Skills & Focus Areas</h2>
              <div className="skills-grid">
                {teamInfo.skills.map((skill, index) => (
                  <div key={index} className="skill-tag">
                    {skill}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={`team-cta ${isVisible ? 'animate-fade-in' : ''}`}>
            <h2>Interested in Joining?</h2>
            <p>We're looking for compassionate volunteers who want to make a direct impact in the lives of seniors.</p>
            <div className="team-cta-buttons">
              <Link to="/get-involved" className="btn btn-primary">
                Get Involved
              </Link>
              <Link to="/teams" className="btn btn-secondary">
                View All Teams
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VolunteeringTeamPage;

